/**
 * Centralized error logging service for the frontend.
 * 
 * This service provides a consistent way to log errors throughout the application.
 * In the future, this can be extended to integrate with error tracking services
 * like Sentry, LogRocket, etc.
 */

/**
 * Log an error with optional error object.
 * 
 * @param message - Error message to log
 * @param error - Optional Error object or other error data
 */
export const logError = (message: string, error?: Error | unknown): void => {
  // In development, log to console for debugging
  if (process.env.NODE_ENV === 'development') {
    console.error(message, error);
  } else {
    // In production, still log to console but could send to error tracking service
    // TODO: Integrate with error tracking service (Sentry, LogRocket, etc.)
    console.error(message, error);
  }
  
  // Future: Send to error tracking service
  // if (window.Sentry) {
  //   window.Sentry.captureException(error || new Error(message));
  // }
};

/**
 * Log a warning message.
 * 
 * @param message - Warning message to log
 * @param data - Optional additional data
 */
export const logWarning = (message: string, data?: unknown): void => {
  // In development, log to console for debugging
  if (process.env.NODE_ENV === 'development') {
    console.warn(message, data);
  } else {
    // In production, still log to console but could send to error tracking service
    console.warn(message, data);
  }
};

/**
 * Log an informational message (for debugging).
 * Only logs in development mode.
 * 
 * @param message - Info message to log
 * @param data - Optional additional data
 */
export const logInfo = (message: string, data?: unknown): void => {
  // Only log in development
  if (process.env.NODE_ENV === 'development') {
    console.log(message, data);
  }
};


